import { render } from "./DateTimeView.vue?vue&type=template&id=0571a31e"
import script from "./DateTimeView.vue?vue&type=script&lang=js"
export * from "./DateTimeView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Work\\huabiao-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__